
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
	navigation: false,
	station: false,
	startdate: false,
	enddate: false,
	rentaltype: 0,
	rentalcomment: '',
	billKey: false,
	voucher: false,
	car: false,
	prices: false,

	estimated_km: false,

	user_session: Cookies.get('user_session') || false,
	sid: false,

};

export default {
	namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/orm/reservation/index.js